export default __webpack_public_path__ + "static/media/clearSky.79682a30.svg";